export default {"src":"/_next/static/media/20-icon.14d8206d.svg","height":46,"width":30,"blurWidth":0,"blurHeight":0};